import { jsx as _jsx } from "react/jsx-runtime";
import 'regenerator-runtime/runtime';
import { render } from 'react-dom';
import { InertiaApp } from '@inertiajs/inertia-react';
import { AppProvider } from '~/context';
var app = document.getElementById('app');
if (app) {
    render(_jsx(AppProvider, { children: _jsx(InertiaApp, { initialPage: JSON.parse(app ? app.dataset.page : '{}'), resolveComponent: function (name) { return import("./src/pages/" + name).then(function (module) { return module.default; }); } }, void 0) }, void 0), app);
}
